/*
 * @Author: <pcjser> 
 * @Date: 2018-04-19 09:07:17 
 * @Last Modified by: pcjser
 * @Last Modified time: 2018-06-05 15:41:05
 */
import React from 'react';
import { NavLink } from 'react-router-dom';
import './nav.scss';

const navList = [
  {
    icon: 'game',
    name: '游戏中心',
    to: '/gameCenter'
  },
  {
    icon: 'charge',
    name: '游戏直充',
    to: '/gameCharge'
  },
  {
    icon: 'vip',
    name: '贵宾中心',
    to: '/vipCenter'
  }
]

const MainNav = () => {
  const platform = window.localStorage.getItem('fw-platform')
  return platform === 'fengwanI' ? null : (
    <ul className="component-nav">
      {
        navList.map(({ icon, name, ...props }, index) => (
          <NavLink {...props} key={`nav-${index}`} className="nav-item" activeClassName="active">
            <i className={`icon ${icon}`}></i>
            <p className="name">{name}</p>
          </NavLink>
        ))
      }
    </ul>
  )
}

export default MainNav


// WEBPACK FOOTER //
// ./src/components/MainNav/index.jsx